module.exports = __webpack_public_path__ + "img/kommune-926.141d17fa.svg";